import React from 'react';
import _ from 'lodash';
import { FILTER_OPTIONS, SLIDERS_DATA } from './filter_constants_and_helpers';

class BaseFilter extends React.Component {
    constructor(props) {
        super(props)
        this.storageKey = this.props.storagePrefix + props.itemType + "_" + this._getFilterName()

        this.stored = props.storage.getOrNull(this.storageKey)

        this.state = {
            visible: props.visible
        }

        this._setDefault = this._setDefault.bind(this)
        this.setFilters = this.setFilters.bind(this)
        this.removeFilter = this.removeFilter.bind(this)
        this.updateByItemProp = false
    }

    componentDidMount() {
        this.setFilters(this._getFilterName(),this._getFilterValue(),this.removeFilter,true)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (!_.isEqual(nextProps.itemFilters, this.props.itemFilters) && this.updateByItemProp){
            const newValues = this._itemValue(nextProps.itemFilters);
            this.setFilters(this._getFilterName(), newValues)
        }
    }

    setFilters(filterName,newValue,xClicked = this.removeFilter,firstLoad = false) {
        this.setState(newValue)
        this.props.storage.set(this.storageKey,newValue)
        this.stored = newValue
        let isDefault = _.isEqual(newValue, this._defaultValue())
        let apiValues = {}
        let newApiValue = this._apiValues(newValue)

        /**
         * Not all keys we need for UI maintenance are relevant for the backend api.
         * get only the relevant
         */
        for (let key of this._apiKeys() ) {
            apiValues[key] = newApiValue[key]
        }

        if (!firstLoad) {
            dataLayer.push({
                'event': 'GTM event To GA',
                'GA_event_category': "Recent deals",
                'GA_event_action': "Filters on " + this.props.itemType + " page used",
                'GA_event_label': filterName
            });
        }

        this.props.setFilters(filterName,apiValues,isDefault,xClicked,this._tagName(newValue))
    }

    // provide a default remove filter (by tag) - simply set default. Child filters can override this.
    removeFilter(name) {
        this._setDefault()
    }

    render() {
        // if visible return the child classes render function.
        return this.props.visible ? this._render() : null
    }

    /**
     * For some filters (color for example) - we want to send a different value to the API then we show.
     * This function will allow these filters to override and refactor the api value based on the input.
     * @param values - the input value
     * @returns {*}
     * @private
     */
    _apiValues(values) {
        return values
    }

    /**
     * Helper function for some of the filters (specifically color and clarity) - that have inter-values.
     * i.e. colors D,E also have a color D-E.
     * This function adds the inter-values whenever both values are selected.
     * @param selectedValues
     * @param filterType
     * @private
     */
    _findInterValues(selectedValues, filterType) {
        // Older versions of the filter used to support single value not in array.
        if ( typeof selectedValues.in === "number" ) {
            selectedValues.in = [selectedValues.in]
        }
        // get the selected names for the values.
        let selectedNames = selectedValues.in.map(cid => {
            let detail = FILTER_OPTIONS[filterType].find(c => c.id === cid)
            if ( detail ) {
                return detail.pretty_name
            }
        }).filter(v => v !== undefined)

        // iterate options and see if any 2 are selected
        for (let cindex = 0 ; cindex < SLIDERS_DATA[filterType].length-2 ; cindex++) {
            // check if 2 consecutive items are selected.
            if ( selectedNames.includes(SLIDERS_DATA[filterType][cindex]) &&
                selectedNames.includes(SLIDERS_DATA[filterType][cindex+1]) ) {
                // we need to add an interim.
                let toAdd = FILTER_OPTIONS[filterType].find(c => c.pretty_name === SLIDERS_DATA[filterType][cindex] + "-" + SLIDERS_DATA[filterType][cindex+1])
                if  (toAdd) {
                    selectedNames.push(toAdd.pretty_name)
                }
            }
        }

        // return an array of the selected ids
        return selectedNames.map(cname => FILTER_OPTIONS[filterType].find(c => c.pretty_name === cname).id)
    }

    /**
     * dropdown filters can remove single values, and since there are several dropdowns - this is a good place for shared code.
     * @param name - the name of the filter value to remove.
     * @param suffix - the filter suffix (in the tag name)
     * @private
     */
    _dropDownRemoveFilter(name,suffix) {

        if ( name.endsWith(suffix) ) {
            name = name.substring(0,name.length-suffix.length)
        }

        let newValues = this._defaultValue()
        if ( name ) {
            let id = this.options.find(e => e.pretty_name == name).id
            newValues.in = this.state.in.filter(e => e !== id)
            newValues.is = []
            if (newValues.not_in) {
                newValues.not_in = this.state.not_in.filter(e => e !== id)
            }
        }
        return [...newValues.in, ...(newValues.not_in ? newValues.not_in : []), ...(newValues.is ? newValues.is : [])]
    }
}

/**
 * Add implementations for abstract functions.
 */
['_apiKeys','_tagName','_defaultValue','_setDefault','_getFilterValue','_render','_getFilterName'].forEach((f) => {
    BaseFilter.prototype[f] = function() {
        throw new Error("This is a base class function. the inheriting class " + this.constructor.name + " needs to implement "+f+"()")
    }
})

export default BaseFilter;